var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 15",
    className: "transition-colors duration-300 fill-[#2E2E2E]",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.82a5.833 5.833 0 0 0-5.833 5.833v4.084a.583.583 0 0 0 .583.583H3.5a1.75 1.75 0 0 0 1.75-1.75V9.403a1.75 1.75 0 0 0-1.75-1.75H2.334a4.667 4.667 0 1 1 9.333 0H10.5a1.75 1.75 0 0 0-1.75 1.75v1.167a1.75 1.75 0 0 0 1.75 1.75h1.75a.583.583 0 0 0 .584-.583V7.653A5.833 5.833 0 0 0 7 1.82zm-3.5 7a.583.583 0 0 1 .584.583v1.167a.583.583 0 0 1-.584.583H2.334V8.82H3.5zm8.167 2.333H10.5a.583.583 0 0 1-.583-.583V9.403a.583.583 0 0 1 .583-.583h1.167v2.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.e0c4bbdaae90b9aa9030e261883b042d.svg";
export { ForwardRef as ReactComponent };